export const CLASS_NAMES = {
  documentContainer:
    'flex flex-col bg-neutral-100 border border-neutral-100 md:w-full h-full overflow-x-scroll overflow-y-scroll -mx-2 mt-4 md:mt-10 md:m-0 md:mt-6 min-h-100 max-h-240',
  documentPadding: 'flex flex-1 w-180 p-2 mx-auto',
  document: 'mx-auto',
};

export const PLACEHOLDER_TEXT =
  "Hang tight, we're just loading your documents in";
